import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import shubham_res from "../pdf/Shubham_resume.pdf";

const About = ({ data }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  if (!data) return null;

  const { name, image, bio, address, phone, email } = data;
  const profilepic = "images/" + image;

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <section id="about" ref={ref}>
      <div className="row">
        <div className="three columns">
          <motion.img
            className="profile-pic"
            src={profilepic}
            alt="Shubham Singh Profile Pic"
            variants={imageVariants}
            initial="hidden"
            animate={controls}
          />
        </div>
        <motion.div
          className="nine columns main-col"
          variants={variants}
          initial="hidden"
          animate={controls}
        >
          <h2>About Me</h2>
          <p>{bio}</p>
          <div className="row">
            <div className="columns contact-details">
              <h2>Contact Details</h2>
              <p className="address">
                <span>{name}</span>
                <br />
                <span>{phone}</span>
                <br />
                <span>{email}</span>
              </p>
            </div>
            <div className="columns download">
              <p>
                <motion.a
                  href={shubham_res}
                  download="shubham_resume"
                  className="button"
                  whileHover={{ y: -5, boxShadow: "0px 5px 15px rgba(0,0,0,0.3)" }}
                  whileTap={{ scale: 0.95 }}
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  <motion.div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(120deg, transparent, rgba(255,255,255,0.3), transparent)",
                      transform: "skewX(-20deg)",
                    }}
                    animate={{ x: ["-100%", "200%"] }}
                    transition={{
                      repeat: Infinity,
                      repeatDelay: 1,
                      duration: 1.5,
                      ease: "easeInOut",
                    }}
                  />
                  <span style={{ position: "relative", zIndex: 1 }}>
                    <i className="fa fa-download"></i>Download Resume
                  </span>
                </motion.a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
